import {signal, WritableSignal} from '@angular/core';

export const consentBannerVisibilitySignal: WritableSignal<boolean> = signal(false);
